// Sub Filter Tabs Component
// Tabs for filtering trades by status (Pending, Active, Closed) + Analytics button
import React from 'react';
import { Hourglass, Play, Archive, PieChart } from 'lucide-react';
import { Button } from '../ui/button';

const SubFilterTabs = ({
  language,
  activeFilter,
  onFilterChange,
  counts, // { pending, active, closed }
  showAnalyticsButton = false,
  showAnalytics = false,
  onToggleAnalytics,
  variant = 'paper' // 'paper' or 'real'
}) => {
  const isPaper = variant === 'paper';
  
  // Color configurations based on variant
  const closedBgActive = isPaper ? 'bg-purple-500 hover:bg-purple-600' : 'bg-primary hover:bg-primary/90';
  const closedBorderInactive = isPaper ? 'border-purple-500/30 text-purple-400' : 'border-primary/50 text-primary';
  const analyticsBgActive = isPaper ? 'bg-purple-600 hover:bg-purple-700' : 'bg-primary hover:bg-primary/90';
  const analyticsBorderInactive = isPaper ? 'border-purple-500/50 text-purple-400' : 'border-primary/50 text-primary';

  return (
    <div className="flex flex-wrap gap-2">
      {/* Pending Button */}
      <Button
        variant={activeFilter === 'pending' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onFilterChange('pending')}
        className={activeFilter === 'pending' ? 'bg-orange-500 hover:bg-orange-600' : 'border-orange-500/50 text-orange-400'}
        data-testid="filter-pending"
      >
        <Hourglass className="w-4 h-4 mr-1" />
        {language === 'fr' ? 'En attente' : 'Pending'} ({counts.pending})
      </Button>
      
      {/* Active Button */}
      <Button
        variant={activeFilter === 'active' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onFilterChange('active')}
        className={activeFilter === 'active' ? 'bg-yellow-500 hover:bg-yellow-600 text-black' : 'border-yellow-500/50 text-yellow-400'}
        data-testid="filter-active"
      >
        <Play className="w-4 h-4 mr-1" />
        {language === 'fr' ? 'En cours' : 'Active'} ({counts.active})
      </Button>
      
      {/* Closed Button */}
      <Button
        variant={activeFilter === 'closed' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onFilterChange('closed')}
        className={activeFilter === 'closed' ? closedBgActive : closedBorderInactive}
        data-testid="filter-closed"
      >
        <Archive className="w-4 h-4 mr-1" />
        {language === 'fr' ? 'Terminés' : 'Closed'} ({counts.closed})
      </Button>
      
      {/* Analytics Button - Only show when on closed tab and has closed trades */}
      {showAnalyticsButton && (
        <Button
          variant={showAnalytics ? 'default' : 'outline'}
          size="sm"
          onClick={onToggleAnalytics}
          className={showAnalytics ? analyticsBgActive : analyticsBorderInactive}
          data-testid="filter-analytics"
        >
          <PieChart className="w-4 h-4 mr-1" />
          {language === 'fr' ? 'Analyse' : 'Analytics'}
        </Button>
      )}
    </div>
  );
};

export default SubFilterTabs;
